export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
export const REMOVE_TRANSACTION = 'REMOVE_TRANSACTION';
export const CLEAR_TRANSACTION = 'CLEAR_TRANSACTION';
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
